export class TeamsPresenter {
  normalizeCreatePayload(input = {}) {
    const name = typeof input.name === 'string' ? input.name.trim() : '';
    if (!name) {
      throw new Error('Team name is required');
    }

    const type = typeof input.type === 'string' ? input.type.trim() : '';
    if (!type) {
      throw new Error('Team type is required');
    }

    const tool = typeof input.tool === 'string' ? input.tool.trim() : '';
    const token = typeof input.token === 'string' ? input.token.trim() : '';
    const boardUrl = typeof input.boardUrl === 'string' ? input.boardUrl.trim() : '';

    let teamId = null;
    if (input.teamId != null) {
      const candidate = String(input.teamId).trim();
      teamId = candidate.length ? candidate : null;
    }

    const teamData = { name, type };
    if (tool) {
      teamData.tool = tool;
    }
    if (token) {
      teamData.token = token;
    }
    if (boardUrl) {
      teamData.board_url = boardUrl;
    }
    if (teamId) {
      teamData.teamId = teamId;
    }

    const selection = {
      type,
      tool: tool || null,
      token: token || null,
      boardUrl: boardUrl || null,
      teamId,
    };

    return {
      teamData,
      logoFile: input.logoFile || null,
      selection,
    };
  }

  formatCreateSuccess(team) {
    const name = team?.name || 'Team';
    return `Team "${name}" created.`;
  }


}

if (typeof window !== 'undefined') {
  window.AgileProPresenters = window.AgileProPresenters || {};
  window.AgileProPresenters.TeamsPresenter = TeamsPresenter;
}
